/*    
<summary>
   This is the Tenants Component which shows the Tenants Data.
   Developer: Mohammad Saquib Khan, Created Date:17-August-2023
</summary>
<param>No Parameter Passed</param>
<returns>Returns JSX</returns>
*/
import React, { SyntheticEvent, useEffect, useState } from "react";
import "./tenants.css";
import { FormattedMessage } from "react-intl";
import { useStore } from "../../contexts/StoreProvider";
import IPageInfo, { IActionFormatter, IPageLimitInfo } from "../../models/ICommon";
import { formatMessage } from "../../translations/format-message";
import LoaderButton from "../../shared-components/Button/LoaderButton";
import Grid from "../../shared-components/Grid/Grid";
import { observer } from "mobx-react";
import "react-sliding-side-panel/lib/index.css";
import {
  ActionFormatter,
  TenantActiveInactiveButtonFormatter,
} from "../../shared-components/Grid/GridFormatter";
import { ITenantList } from "../../models/response/ITenantResponse";
import {
  faKey,
  faPencilAlt,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import AddTenantPopupHOC from "./hoc/AddTenantPopupHOC";
import AddEditTenant from "./add-edit-tenant/add-edit-tenant";
import Pagination from "../../shared-components/Grid/Pagination";
import DeletePopup from "../../shared-components/popup/delete/delete-popup";
import toast from "react-hot-toast";
import DeletePopupHOC from "../../shared-components/popup/delete/delete-popup-hoc";
import ChangePasswordPopupHOC from "../../shared-components/popup/change-password/change-password-popup-hoc";
import ChangePasswordTenant from "./add-edit-tenant/change-password-tenant";
import ConfirmPopup from "../../shared-components/popup/confirm/confirm-popup";
import DeleteConfirmPopup from "../../shared-components/confirmationPopup/confirm-popup";
import ConfirmPopupHOC from "../../shared-components/popup/confirm/confirm-popup-hoc";
import FormLoader from "../../shared-components/FormLoader/FormLoader";
import userSettingEnum from "../../constants/user-setting-enum";
import SlidingPanel from "react-sliding-side-panel";
import TenantDetails from "./tenant-detail";
import { isOperationPermitted, showIcons } from "../../helpers/action-permission-helper";
import systemModuleEnum from "../../constants/system-module-enum";
import { getRoleNameFromLocalStorage, getRoleTypeFromLocalStorage } from "../../helpers/local-stotrage-helper";
import { readOnly } from "../../constants/common-constants";
import ConfirmUnblockPopupHOC from "../../shared-components/popup/unblock/confirm-unblock-popup-hoc";
import roleTypeEnum from "../../constants/role-type-enum";
import noicon from "../../assets/Images/svg/no-group.svg"
import config from "../../helpers/config-helper";

const appConfig = config();
const is2FEnabled = appConfig.IS_2F_ENABLED;

const Tenants = (props: any) => {
  const { preferencesStore, tenantStore, userStore } = useStore();
  const {
    UpdateUserBlockStatusService,
    resetUserBlockState, 
    userBlockState
  } = userStore;
  const {
    userSetting,
    setUserSetting,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;
  const {
    GetTenantListService,
    tenantDataList,
    allTenantlist,
    addUpdateTenantState,
    DeleteTenantService,
    deleteTenantState,
    reset,
    UpdateTenantStatusService,
    activeInactiveState,
    resetActiveInactiveState,
    inProgress,
    exportAllTenantsService,
    resetGetTenantDetail
  } = tenantStore;
  const [selectedId, setSelectedId] = useState<number>(0);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [openPanel, setOpenPanel] = useState(false);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const allTenantsList: Array<ITenantList> = allTenantlist;
  const pageLimitOptions: Array<number> = [10, 50, 100, 1000];
  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.tenantLimitConfig,
    isPageLimitChange: false,
  });
  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  /**
   * This function calls the "getAllGroup" store funtion that get configuration list from API
   */
  const callGetAllTenants = () => {
    GetTenantListService(pageInfo.currentPage, pageLimitInfo.pageLimit);
  };

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(
      userSettingEnum.TenantLimitConfig,
      parseInt(evt.target.value)
    );
  };
  /**
   * This function shows the add group pop up from where we can add new group and update existing group prootcol. we use id to identify
   * that we are adding or updating group.
   * "Id == -1" : we are adding new group
   * "Id != -1" : means we are updating existing group
   */
  const openAddTenantHandler = (row: { Id: number; userId: number }, event: any) => {
    event.stopPropagation();
    closePanelhandler();
    setSelectedRow(row);
    props.addTenantToggleHandler();
  };

  const deleteTenantHandler = (row: { Id: number }, event: any) => {
    event.stopPropagation();
    closePanelhandler();
    setSelectedId(row.Id);
    props.deletePopupToggleHandler();
  };

  /**
   * This function deletes the tenant by providing Id to the Api
   */
  const deleteHandler = () => {
    DeleteTenantService(selectedId);
  };

  /**
   * This function shows the change password popup component and sets the seleted user Id
   */
  const changePasswordClickHandler = (row: any, event: any) => {
    event.stopPropagation();
    closePanelhandler();
    setSelectedId(row.UserId);
    props.changePasswordToggleHandler();
  };

  /**
   * This function will update the shows the  confirm popup
   */
  const activeInactivePopupHandler = (
    row: any,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    e.stopPropagation();
    closePanelhandler();
    setSelectedRow({ ...row, isActive: e.target.checked });
    props.confirmPopupToggleHandler();
  };

  /**
     * This function will update the shows the  confirm popup
     */
    const userUnblockStatusPopupHandler = (
      row: ITenantList,
      e: React.ChangeEvent<HTMLInputElement>
    ) => {
      e.stopPropagation();
      closePanelhandler();
      setSelectedRow({ ...row, IsUserAccountBlocked: e.target.checked });
      props.confirmUnblockPopupToggleHandler();
    };

  /**
   * This function will update the Activate / DeActivate the Stability of the User
   */
  const activeInactiveHandler = () => {
    // closePanelhandler();
    UpdateTenantStatusService(selectedRow.Id, selectedRow.isActive);
  };

  /**
   * This function will unblock the user
   */
  const unBlockStatusHandler = () => {
    UpdateUserBlockStatusService(selectedRow.UserId, selectedRow.IsUserAccountBlocked);
  };

  function rowClassFormat(row: any, rowIdx: number) {
    let className: string = "";
    if (selectedRow && row.Id === selectedRow.Id) {
      className = "bg-row SelectedRow";
    }
    return className;
  }


  const rowEvents = (e: SyntheticEvent, row: any, rowIndex: number) => {
    setSelectedId(row.Id);
    setSelectedRow(row);
    setOpenPanel(true);
  };

  const closePanelhandler = () => {
    setSelectedRow({});
    resetGetTenantDetail();
    setOpenPanel(false);
    // tenantStore.reset();
  };


  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "pageLimitInfo.pageLimit" of the useEffect changed.
   */
  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      callGetAllTenants();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageLimitInfo.pageLimit]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "GroupList" of the useEffect changed.
   */
  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      totalPages: tenantDataList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantDataList]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "pageInfo.currentPage" of the useEffect changed.
   */
  useEffect(() => {
    if (pageInfo.isPagerChange) {
      callGetAllTenants();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateGroupstate.success" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateTenantState.success) {
      callGetAllTenants();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateTenantState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "activeInactiveState.success" of the useEffect changed.
   */
  useEffect(() => {
    if (activeInactiveState.success) {
      toast.success(formatMessage("updated_success"));
      resetActiveInactiveState();
      props.confirmPopupToggleHandler();
      callGetAllTenants();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeInactiveState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "activeInactiveState.error" of the useEffect changed.
   */
  useEffect(() => {
    if (activeInactiveState.error) {
      toast.error(formatMessage(activeInactiveState.error));
      resetActiveInactiveState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeInactiveState.error]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "userBlockState.success" of the useEffect changed.
   */
  useEffect(() => {
    if (userBlockState.success) {
      toast.success(formatMessage("updated_success"));
      resetUserBlockState();
      props.confirmUnblockPopupToggleHandler();
      callGetAllTenants();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userBlockState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "userBlockState.error" of the useEffect changed.
   */
  useEffect(() => {
    if (userBlockState.error) {
      toast.error(formatMessage(userBlockState.error));
      resetUserBlockState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userBlockState.error]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "deleteTenantSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (deleteTenantState.success) {
      toast.success(formatMessage("deleted_success"));
      reset();
      props.deletePopupToggleHandler();
      callGetAllTenants();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteTenantState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "islanguageChanged" of the useEffect changed.
   */
  useEffect(() => {
    if (islanguageChanged) {
      callGetAllTenants();
      updateLanguageChangedFlag();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [islanguageChanged]);

  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered
   * while a dependency of the useEffect has changed.
   */
  useEffect(() => {
    callGetAllTenants();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const actionIcons: IActionFormatter[] = showIcons([
    {
      dataField: "isEdit",
      handler: openAddTenantHandler,
      icon: faPencilAlt,
      isDisable: true,
      title: "edit",
      action: "edit",
      varient: "primary",
    },
    {
      dataField: "isData",
      handler: changePasswordClickHandler,
      icon: faKey,
      isDisable: true,
      title: "change_password",
      action: "edit",
      varient: "secondary",
    },
    {
      dataField: "isDelete",
      handler: deleteTenantHandler,
      icon: faTrashAlt,
      isDisable: true,
      title: "delete",
      action: "delete",
      varient: "danger",
    },
  ], systemModuleEnum.Tenant);
  /**
   * The column constant defines the column description for the user grid (table)
   */
  const columns: any = [
    {
      dataField: "TenantName",
      text: formatMessage("tenant_name"),
      title: (cell: string, row: any) => {
        return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: "Email",
      text: formatMessage("tenant_email"),
      title: (cell: string, row: any) => {
        return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: "OrganizationId",
      text: formatMessage("organization_id"),
    },
    {
      dataField: "OrganizationName",
      text: formatMessage("organization_name"),
      title: (cell: string, row: any) => {
        return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: "ContactPersonName",
      text: formatMessage("contact_person_name"),
    },
    {
      dataField: "ContactPhoneNumber",
      text: formatMessage("contact_phone_number"),
      hidden: true,
    },
    {
      dataField: "ContactEmail",
      text: formatMessage("contact_email"),
      title: (cell: string, row: any) => {
        return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: "Address",
      text: formatMessage("address"),
      hidden: true,
    },
    // {
    //   dataField: "IsTrialTenant",
    //   text: formatMessage("tenant_type"),
    //   classes: "text-start",
    //   formatter: (cell: any, row: any) => (
    //     <span
    //       className={`badge ${cell ? "bg-warning" : "bg-success"} p-1`}
    //     >
    //       <FormattedMessage id={cell ? "trial" : "paid"} />
    //     </span>
    //   ),
    // },
    {
      dataField: "IsActive",
      text: formatMessage("is_active"),
      formatter: TenantActiveInactiveButtonFormatter(
        activeInactivePopupHandler
      ),
      hidden: !isOperationPermitted(systemModuleEnum.Tenant, "Edit"),
    },
    {
      dataField: "IsUserAccountBlocked",
      text: formatMessage("account_status"),
      formatter: (cell: any, row: any) => {
        return (
          <>
            {row.IsUserAccountBlocked &&
              <div className="d-flex align-items-center">
                <span className="badge bg-danger"><FormattedMessage id="blocked" /></span>
                <button type="button" title={formatMessage("unblock")} onClick={(e: any) => { userUnblockStatusPopupHandler(row, e);}} className="btn btn-sm btn-light d-flex align-items-center" >
                  <svg height="16px" viewBox="-64 0 512 512" width="16px" xmlns="http://www.w3.org/2000/svg" id="fi_1828500"><path d="m85.332031 234.667969c-11.796875 0-21.332031-9.558594-21.332031-21.335938v-85.332031c0-70.59375 57.40625-128 128-128s128 57.40625 128 128c0 11.777344-9.535156 21.332031-21.332031 21.332031s-21.335938-9.554687-21.335938-21.332031c0-47.0625-38.269531-85.332031-85.332031-85.332031s-85.332031 38.269531-85.332031 85.332031v85.332031c0 11.777344-9.539063 21.335938-21.335938 21.335938zm0 0" fill="#607d8b"></path><path d="m336 192h-288c-26.453125 0-48 21.523438-48 48v224c0 26.476562 21.546875 48 48 48h288c26.453125 0 48-21.523438 48-48v-224c0-26.476562-21.546875-48-48-48zm0 0" fill="#ffc107"></path></svg>
                </button>
              </div>
            }
          </>
        )
      },
      hidden: (((getRoleTypeFromLocalStorage() == roleTypeEnum.SystemAdmin) || 
      (getRoleTypeFromLocalStorage() == roleTypeEnum.TenantAdmin)) && is2FEnabled) ? false : true,
    },
    {
      dataField: "",
      formatter: ActionFormatter(actionIcons),
      text: formatMessage("actions"),
      hidden: actionIcons.length === 0 ? true : false,
    },
  ];

  return (
    <React.Fragment>
      {props.showAddTenantPopup && (
        <AddEditTenant
          selectedRow={selectedRow}
          modalClosed={()=>{
            closePanelhandler()
            props.addTenantToggleHandler();
          }}
        />
      )}
      {/* {props.showDeletePopup && (
        <DeletePopup
          title="delete_tenant"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_tenant_confirm"
          isLoading={deleteTenantState.inProgress}
        />
      )} */}
      {props.showConfirmUnblockPopup && (
        <ConfirmPopup
          size="sm"
          title="unblock_user_title"
          modalSubmit={unBlockStatusHandler}
          modalClosed={props.confirmUnblockPopupToggleHandler}
          message="unblock_user_info"
          isLoading={userBlockState.inProgress}
        />
      )}
      {props.showDeletePopup && (
        <DeleteConfirmPopup
          title="delete_tenant"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_tenant_confirm"
          dialogClassName="delete_popup"
          category="delete"
          isLoading={deleteTenantState.inProgress}
        />
      )}
      {props.showConfirmPopup && (
        <ConfirmPopup
          title="tenant_account_status"
          modalSubmit={activeInactiveHandler}
          modalClosed={props.confirmPopupToggleHandler}
          message="active_inactive_account_status"
          isLoading={activeInactiveState.inProgress}
        />
      )}
      {props.showChangePasswordPopup && (
        <ChangePasswordTenant
          id={selectedId}
          modalClosed={props.changePasswordToggleHandler}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div id="moveContent">
          <div className="container-fluid">
            <div className="row g-0  align-items-center">
              <div className="col-sm-6 col-12">
                <div className="filter-left-area">
                  <ul className="d-flex align-items-center">
                    <li>
                      <p className="h5 ps-5 mb-0">
                        <FormattedMessage id="tenants" />
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-sm-6 col-12">
                <div className="add-list">
                  <ul className="d-flex align-items-center">
                    {
                      isOperationPermitted(systemModuleEnum.Tenant, "Add") &&
                      <li title={formatMessage("add_tenant")}>
                        <LoaderButton
                          id="AddTenants"
                          text="+_add_tenant"
                          onClick={(event: any) =>
                            openAddTenantHandler({ Id: -1, userId: -1 }, event)
                          }
                        />
                      </li>
                    }
                    {
                      isOperationPermitted(systemModuleEnum.Tenant, "View") &&
                      <li
                        title={formatMessage("export_all_tenant")}
                        className={`mx-2 ${allTenantsList.length == 0 ? "disabled" : ""}`}
                      >
                        <LoaderButton
                          id="ExportAllTenants"
                          text="export_all_tenant"
                          disabled={allTenantsList.length == 0}
                          onClick={() => {
                            closePanelhandler();
                            exportAllTenantsService()
                          }}
                        />
                      </li>
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {inProgress && <FormLoader loading={inProgress} />}
      <div
        className={`card mt-3 changingPanel ${openPanel ? "panelOpen" : ""
          }`}
      >
        <div className="tableDesign row-eq-height tableDevices ">
          <div className="table-responsive" data-testid="table">
            {allTenantsList.length > 0 && (
              <Grid
                data={allTenantsList}
                columns={columns}
                keyField="Id"
                loading={false}
                rowEvents={{ onClick: rowEvents }}
                rowClasses={rowClassFormat}
              />
            )}
            {allTenantsList.length == 0 && (
              <div className="message text-center">
                <img src={noicon} className="no_message" alt="" />
                <p className="noData text-muted text-center h4">
                  <FormattedMessage id="no_tenants" />
                </p>
                <p className="mb-3">
                  <FormattedMessage id={"no_tenants_message"} />
                </p>
                {
                  isOperationPermitted(systemModuleEnum.Tenant, "Add") &&
                  <LoaderButton
                    text="add_tenant"
                    onClick={(event: any) => openAddTenantHandler({ Id: -1, userId: -1 }, event)}
                  />
                }
              </div>
            )}
          </div>
        </div>

        {allTenantsList.length > 0 ? (
          <div className="row g-0 p-2 tableFooter">
            <div className="col-sm-6">
              <FormattedMessage id="show" />
              <select
                data-testid="pageSelect"
                className="pageLimit"
                onChange={onPageLimitChanged}
                value={pageLimitInfo.pageLimit}
              >
                {pageLimitOptions.map((op: any) => (
                  <option key={op} value={op}>
                    {op}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-sm-6 d-flex justify-content-sm-end">
              <Pagination
                isRefreshPage={false}
                totalPages={pageInfo.totalPages}
                pageLimit={pageLimitInfo.pageLimit}
                onPageChanged={onPageChanged}
                disablePagination={disablePagination}
                setIsRefreshPage={setIsRefreshPage}
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      <SlidingPanel
        type={"right"}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel">
          <div className="row bb p-2 g-0">
            <div className="col-lg-11">
              <h2 className="fw-bold mb-0 mt-2">
                {/* <FormattedMessage id={"billing_details"} /> */}
                {selectedRow.TenantName}
              </h2>
            </div>
            <div className="col-lg-1 text-end">
              <button onClick={closePanelhandler} className="Crossicons" title={formatMessage("close")}>
                <svg
                  role="button"
                  xlinkTitle="close"
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  className="bi bi-x"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </button>
            </div>
          </div>
          <TenantDetails selectedData={selectedRow} />
        </div>
      </SlidingPanel>
    </React.Fragment>
  );
};

export default ConfirmUnblockPopupHOC(ConfirmPopupHOC(
  ChangePasswordPopupHOC(AddTenantPopupHOC(DeletePopupHOC(observer(Tenants))))
));
